<template>
    <transition name="modal">
        <div class="modal" v-if="show" @click="handleOutsideClick">
            <div class="content row" ref="content">
                <h3>{{ title }}</h3>
                <p>{{ message }}</p>
                <div class="buttons">
                    <button class="btn transparent rounded-medium big" @click="$emit('cancel')">{{ cancelText }}</button>
                    <button class="btn btn-secondary rounded-medium big" @click="$emit('confirm')">{{ confirmText }}</button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        show: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        },
        message: {
            type: String,
            default: ''
        },
        cancelText: {
            type: String,
            default: 'Cancelar'
        },
        confirmText: {
            type: String,
            default: 'Confirmar'
        }
    },
    methods: {
        handleOutsideClick(event) {
            // Verifica se o clique foi fora do conteúdo
            if (this.$refs && this.$refs.content && !this.$refs.content.contains(event.target)) {
                this.$emit('cancel');
            }
        }
    }
};
</script>

<style scoped src="@/assets/css/general/modal-style.css"></style>